<span>{{formattedSchoolYear}}</span>
